import { Model, HasOne, Attr } from 'spraypaint';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';

@Model()
class AuditsExportsTupCollabsExport extends ApplicationRecord {
  static jsonapiType = 'audits-exports-tup_collabs_exports';

  // Attributes
  @Attr() legalEntityId!: string;

  // Extra-attributes

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
}

export default AuditsExportsTupCollabsExport;
